import { PageLayoutDefaultContainer, PageLayoutDefaultMenuNavigationItem } from "@sis/react-library"
import { ScheduleMenuItems } from "../schedule/ScheduleNavigation"
import { ConfigurationsMenuItems } from "../configurations/ConfigurationsNavigation"
import { TrackMenuItems } from "../track/TrackNavigation"
import { LayoutTopAppBarLeft } from "./LayoutTopAppBarLeft"
import { LayoutTopAppBarRight } from "./LayoutTopAppBarRight"
import { LayoutFooter } from "./LayoutFooter"
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { commonRoutes } from "../shared/commonConstants"
import { setMenuExpanded } from "../../redux/common/commonActions"
import { useAppDispatch } from "../../redux/hooks"
import redirectUrl from "../../utils/redirectUrl"

export const LayoutContainer = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const redirect = redirectUrl.get();

    useEffect(() => {
        if (!redirect && location.pathname === commonRoutes.home) {
            navigate(commonRoutes.landing, { replace: true });
        }
        // We want to restrict only location and navigate
        // eslint-disable-next-line
    }, [location, navigate])

    useEffect(() => {
        if (redirect) {
            navigate(redirect, { replace: true });
            redirectUrl.remove();
        }
        // We want to restrict only redirectUrl
        // eslint-disable-next-line
    }, [redirectUrl])

    const menuNavigationList: PageLayoutDefaultMenuNavigationItem[] = [
        ...ScheduleMenuItems(),
        ...ConfigurationsMenuItems(),
        ...TrackMenuItems()
    ]

    const handleMenuExpandedCollaped = (expanded: boolean) => {
        dispatch(setMenuExpanded(expanded));
    }

    return (
        <PageLayoutDefaultContainer
            topAppBarLeft={<LayoutTopAppBarLeft />}
            topAppBarRight={<LayoutTopAppBarRight />}
            menuNavigationList={menuNavigationList}
            footer={<LayoutFooter />}
            onMenuExpandedCollapsed={(expanded) => handleMenuExpandedCollaped(expanded)}            
        />
    )
}
